import { Translatable } from "@icc/shared/helpers";

export class RollerProfile {
    id: number;
    /** Kod zewnętrzny */
    extId: number;
    /** Kod do indeksu */
    indexNo: string;
    /** Nazwa */
    @Translatable({ model: 'Profiles' })
    name: string;
    /** Opis */
    description: string;
    /** Zdjęcie */
    img: string;
    printCode: string;
    /** Zestaw grup kolorów */
    colorGroupSetId: number;
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Waga m2 */
    weightM2?: number;
    /** Margines bezpieczeństwa wagi [%] */
    weightSafetyMargin?: number;
    /** Margines bezpieczeństwa wagi dla napędów sprężynowych [%] */
    springWeightSafetyMargin?: number;
    /** Rzeczywista wysokość profilu [mm] */
    height?: number;
    /** Wysokość rozliczeniowa [mm] */
    billingHeight?: number;
    /** Widoczna wysokość */
    visibleHeight?: number;
    /** Maksymalna powierzchnia */
    maxArea?: number;
    /** Maksymalna szerokość */
    maxWidth?: number;
    /** Czy ustawiony ręcznie czy domyślnie */
    isDefault?: boolean;
}
